import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import './util';
import './util/polyfills';
import './style.css';
import store from './stores';
import * as serviceWorker from './serviceWorker';

import App from './components/App';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
